module.exports = __webpack_public_path__ + "img/서브_자신감.a2f41008.svg";